import { Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Haugen extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "haugen";
    }
}

export function Haugen$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Haugen", void 0, Haugen, Metadata_StringCategory$reflection());
}

export function Haugen_$ctor_Z721C83C5(aName) {
    return new Haugen(aName);
}

export class Countryofheritage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "countryofheritage";
    }
}

export function Countryofheritage$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Countryofheritage", void 0, Countryofheritage, Metadata_StringCategory$reflection());
}

export function Countryofheritage_$ctor_Z721C83C5(aName) {
    return new Countryofheritage(aName);
}

export class Yearofrec extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "yearofrec";
    }
}

export function Yearofrec$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Yearofrec", void 0, Yearofrec, Metadata_StringCategory$reflection());
}

export function Yearofrec_$ctor_Z721C83C5(aName) {
    return new Yearofrec(aName);
}

export class Birth extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birth";
    }
}

export function Birth$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Birth", void 0, Birth, Metadata_StringCategory$reflection());
}

export function Birth_$ctor_Z721C83C5(aName) {
    return new Birth(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Age", void 0, Age, Metadata_StringCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class Agegroup extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "agegroup";
    }
}

export function Agegroup$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Agegroup", void 0, Agegroup, Metadata_StringCategory$reflection());
}

export function Agegroup_$ctor_Z721C83C5(aName) {
    return new Agegroup(aName);
}

export class Fifty extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "fifty";
    }
}

export function Fifty$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Fifty", void 0, Fifty, Metadata_StringCategory$reflection());
}

export function Fifty_$ctor_Z721C83C5(aName) {
    return new Fifty(aName);
}

export class Birthdecade extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "birthdecade";
    }
}

export function Birthdecade$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Birthdecade", void 0, Birthdecade, Metadata_StringCategory$reflection());
}

export function Birthdecade_$ctor_Z721C83C5(aName) {
    return new Birthdecade(aName);
}

export class Parents extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "parents";
    }
}

export function Parents$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Parents", void 0, Parents, Metadata_StringCategory$reflection());
}

export function Parents_$ctor_Z721C83C5(aName) {
    return new Parents(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Area extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "area";
    }
}

export function Area$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Area", void 0, Area, Metadata_StringCategory$reflection());
}

export function Area_$ctor_Z721C83C5(aName) {
    return new Area(aName);
}

export class Subregion extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "subregion";
    }
}

export function Subregion$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Subregion", void 0, Subregion, Metadata_StringCategory$reflection());
}

export function Subregion_$ctor_Z721C83C5(aName) {
    return new Subregion(aName);
}

export class Country extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "country";
    }
}

export function Country$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Country", void 0, Country, Metadata_StringCategory$reflection());
}

export function Country_$ctor_Z721C83C5(aName) {
    return new Country(aName);
}

export class Region extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "region";
    }
}

export function Region$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Region", void 0, Region, Metadata_StringCategory$reflection());
}

export function Region_$ctor_Z721C83C5(aName) {
    return new Region(aName);
}

export class Notes extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "notes";
    }
}

export function Notes$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Notes", void 0, Notes, Metadata_StringCategory$reflection());
}

export function Notes_$ctor_Z721C83C5(aName) {
    return new Notes(aName);
}

export class Majoritylanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "majoritylanguage";
    }
}

export function Majoritylanguage$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Majoritylanguage", void 0, Majoritylanguage, Metadata_StringCategory$reflection());
}

export function Majoritylanguage_$ctor_Z721C83C5(aName) {
    return new Majoritylanguage(aName);
}

export class Otherlanguages extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "otherlanguages";
    }
}

export function Otherlanguages$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Otherlanguages", void 0, Otherlanguages, Metadata_StringCategory$reflection());
}

export function Otherlanguages_$ctor_Z721C83C5(aName) {
    return new Otherlanguages(aName);
}

export class MajoritylanguageWhen extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "majoritylanguage_when";
    }
}

export function MajoritylanguageWhen$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.MajoritylanguageWhen", void 0, MajoritylanguageWhen, Metadata_StringCategory$reflection());
}

export function MajoritylanguageWhen_$ctor_Z721C83C5(aName) {
    return new MajoritylanguageWhen(aName);
}

export class SchoolLanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "school_language";
    }
}

export function SchoolLanguage$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.SchoolLanguage", void 0, SchoolLanguage, Metadata_StringCategory$reflection());
}

export function SchoolLanguage_$ctor_Z721C83C5(aName) {
    return new SchoolLanguage(aName);
}

export class ConfirmationLanguage extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "confirmation_language";
    }
}

export function ConfirmationLanguage$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.ConfirmationLanguage", void 0, ConfirmationLanguage, Metadata_StringCategory$reflection());
}

export function ConfirmationLanguage_$ctor_Z721C83C5(aName) {
    return new ConfirmationLanguage(aName);
}

export class ScandinavianContact extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "scandinavian_contact";
    }
}

export function ScandinavianContact$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.ScandinavianContact", void 0, ScandinavianContact, Metadata_StringCategory$reflection());
}

export function ScandinavianContact_$ctor_Z721C83C5(aName) {
    return new ScandinavianContact(aName);
}

export class VisitsScandinavia extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "visits_scandinavia";
    }
}

export function VisitsScandinavia$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.VisitsScandinavia", void 0, VisitsScandinavia, Metadata_StringCategory$reflection());
}

export function VisitsScandinavia_$ctor_Z721C83C5(aName) {
    return new VisitsScandinavia(aName);
}

export class ReadingScandinavian extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "reading_scandinavian";
    }
}

export function ReadingScandinavian$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.ReadingScandinavian", void 0, ReadingScandinavian, Metadata_StringCategory$reflection());
}

export function ReadingScandinavian_$ctor_Z721C83C5(aName) {
    return new ReadingScandinavian(aName);
}

export class L extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "L";
    }
}

export function L$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.L", void 0, L, Metadata_StringCategory$reflection());
}

export function L_$ctor_Z721C83C5(aName) {
    return new L(aName);
}

export class PlaceInScandinavia extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place_in_scandinavia";
    }
}

export function PlaceInScandinavia$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.PlaceInScandinavia", void 0, PlaceInScandinavia, Metadata_StringCategory$reflection());
}

export function PlaceInScandinavia_$ctor_Z721C83C5(aName) {
    return new PlaceInScandinavia(aName);
}

export class County extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "county";
    }
}

export function County$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.County", void 0, County, Metadata_StringCategory$reflection());
}

export function County_$ctor_Z721C83C5(aName) {
    return new County(aName);
}

export class Generation extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "generation";
    }
}

export function Generation$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Generation", void 0, Generation, Metadata_StringCategory$reflection());
}

export function Generation_$ctor_Z721C83C5(aName) {
    return new Generation(aName);
}

export class Emigrated extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "emigrated";
    }
}

export function Emigrated$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Emigrated", void 0, Emigrated, Metadata_StringCategory$reflection());
}

export function Emigrated_$ctor_Z721C83C5(aName) {
    return new Emigrated(aName);
}

export class Edecade extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "edecade";
    }
}

export function Edecade$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Edecade", void 0, Edecade, Metadata_StringCategory$reflection());
}

export function Edecade_$ctor_Z721C83C5(aName) {
    return new Edecade(aName);
}

export class Gnotes extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "gnotes";
    }
}

export function Gnotes$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Gnotes", void 0, Gnotes, Metadata_StringCategory$reflection());
}

export function Gnotes_$ctor_Z721C83C5(aName) {
    return new Gnotes(aName);
}

export class Genre extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "genre";
    }
}

export function Genre$reflection() {
    return class_type("Corpora.Cans4.MetadataCategories.Genre", void 0, Genre, Metadata_StringCategory$reflection());
}

export function Genre_$ctor_Z721C83C5(aName) {
    return new Genre(aName);
}

